import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import Loader from '../utils/Loader';
import "../../src/assets/scss/global.scss";
import "../../src/assets/scss/helpers/bootstrap.scss";

const Allroutes = () => {
    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route path="*" element={<PrivateRoutes />} />
            </Routes>
        </Suspense>
    );
};

export default Allroutes;


